import Hero from './Hero'
import React from 'react'
import Register from './Register'
import Nav from './Nav';
export default function Home() {

    return (
        <div>
            <Nav />
            <Hero />
        </div>
    );
}
